'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useAnalytics } from './useAnalytics';

export const usePageTracking = () => {
  const pathname = usePathname();
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    if (pathname) {
      // Extract meaningful page names from routes
      const getPageName = (path: string): string => {
        if (path === '/') return 'Dashboard';
        if (path === '/orders') return 'Orders';
        if (path === '/calendar') return 'Calendar';
        if (path === '/products') return 'Products';
        if (path === '/payments') return 'Payments';
        if (path === '/customers') return 'Customers';
        if (path === '/menu-website') return 'MenuMate Link';
        if (path === '/settings') return 'Settings';
        if (path === '/profile') return 'Profile';
        if (path === '/login') return 'Login';
        if (path === '/signup') return 'Signup';
        if (path === '/verify-email') return 'Email Verification';
        if (path.match(/^\/[^/]+$/)) return 'Customer Order Page';
        if (path.match(/^\/[^/]+\/customer-details$/)) return 'Customer Details';
        
        // Handle dynamic routes
        if (path.includes('/orders/')) return 'Order Details';
        if (path.includes('/customers/')) return 'Customer Details';
        
        return path;
      };

      const pageName = getPageName(pathname);
      
      // Track the page view
      trackPageView({
        page: pageName,
        section: pathname.split('/')[1] || 'root',
      });
    }
  }, [pathname, trackPageView]);
};